// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
}

.su-auth-container {
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;
  height: auto;

  background: rgba(239,236,239,0);

  overflow-x: hidden;
  overflow-y: auto;
}

.signup-box {
  background: rgba(234, 229, 234, 1); /* 60% translucent */
  padding: 2rem;
  border-radius: 10px;
  width: 600px;
  max-width: 90%;
  margin: 30px 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.3);
  /* min-height: 800px; */
  text-align: center;
  z-index: 1; /* Ensure login box is above the background */
}

.signup-box h2 {
  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;
  color: black;
  font-size: 60px;
  margin-bottom: 10px;
  font-weight: lighter;
}

/* Input Fields */
input[type="text"],
input[type="loc"],
input[type="tel"],
input[type="date"],
select {
  width: 100%;
  min-height: 40px; 
  padding: 14px;
  border: 1px solid #d1d7d5;
  border-radius: 8px;
  font-size: 18px;
  background-color:white;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
  height: 50px;   
}

input[type="password"],
select {
  width: 100%;
  margin-top: 0;
  min-height: 30px;
  height: 50px; 
  padding: 14px;
  border: 1px solid #d1d7d5;
  border-radius: 8px;
  font-size: 18px;
  background-color:white;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

select[type="scroll"],
select {
  margin-top: 2px;
  width: 100%;
  height: auto;
  max-height: 40px; 
  padding: 14px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 14px;
  background-color:white;
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}

/* For first name and last name */
input[type="text"]:focus, 
input[type="email"]:focus, 
input[type="password"]:focus, 
input[type="tel"]:focus, 
input[type="date"]:focus, 
select:focus {
  border-radius: 10px;
  outline: none;
  border-color: #28a745;
}

/* Terms & Conditions Styling */
.terms-conditions {
  margin-top: 15px;
  display: flex;
  gap: 10px; /* Space between checkbox and label */
  font-size: 14px;
  color: #fff;
  margin-bottom: 20px; /* Space before the Sign-Up button */
  align-items: baseline; /* Align the checkbox and label from the baseline */
}

.submit-otp-btn {
  width: 20%;
  height: 50px; /* Same height as input fields */
  /* padding: 10px; */
  border: 1px solid #020202;
  border-radius: 8px;
  font-size: 14px;
  background-color: #28a745;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  margin-top: 10px;
  margin-left: 20px;
}

/* Checkbox styling */
.terms-conditions input {
  transform: scale(1.2); /* Make checkbox slightly larger */
  cursor: pointer;
  margin: 0; /* Remove default margin */
}

/* Link Styling */
.terms-conditions a {
  color: #007bff;
  text-decoration: none;
}

.terms-conditions a:hover {
  text-decoration: underline;
}

.signin-prompt {
  border-radius: 10px;
  width: 100%;
  height: 40px; 
  margin-top: 10px;
  text-align: center;
  font-size: 16px;
  color: black;
  padding: 5px;
  font-family: "'Trebuchet MS','Lucida Sans Unicode','Lucida Grande','Lucida Sans',Arial,sans-serif;"; 
}

.signin-prompt a {
  color: #007BFF; /* Link color */
  text-decoration: none;
}

.signin-prompt a:hover {
  text-decoration: underline; /* Underline on hover */
}

/* Button Container */
.button-container {
  border-radius: 10px;
  display: flex;
  justify-content: flex-start; /* Aligns button to the right */
  width: 100%; /* Ensures it takes full width of parent */
}

button:disabled {
  /* background-color: #ccc !important; */
  cursor: not-allowed; /* Show disabled cursor */
  /* border: 1px solid #999; */
}

/* Responsive: Stack fields on smaller screens */
@media (max-width: 600px) {
  .form-group-row {
    flex-direction: column;
  }
}

.profilepic {
  /* margin-top: 10px; */
  display: flex;
  align-items: center;
  border: 1px solid #ccc;
  padding: 6px;
  border-radius: 6px;
  background-color: #fff;
  height: 40px;
}

.uploadimage {
  flex-grow: 1;
  /* height: 20px; */
  border: none;
  outline: none;
  padding: 8px;
  font-size: 14px;
  background: transparent;
}

.imageupload {
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.upload-icon {
  color: gray;
  font-size: 18px;
}

.input-field {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.copyright-container {
    color: "black";  
    display: "block";
    font-size: "16px"; 
    text-align: "center";
}

.copyright {
  font-size: 16px;
}

.su-popupStyle {
  position: 'fixed';
  margin-top: '30%';
  left: '50%';
  transform: 'translate(-50%, -30%)';
  background: '#fff';
  padding: '2rem';
  border: '1px solid #ccc';
  border-radius: '10px';
  box-shadow: '0 0 10px rgba(0,0,0,0.2)';
};`, "",{"version":3,"sources":["webpack://./src/components/Pages/PublicLayout/Signuppage/Signup.css"],"names":[],"mappings":"AAAA;;;IAGI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;;EAEnB,WAAW;EACX,YAAY;;EAEZ,+BAA+B;;EAE/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC,EAAE,oBAAoB;EACxD,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uCAAuC;EACvC,uBAAuB;EACvB,kBAAkB;EAClB,UAAU,EAAE,6CAA6C;AAC3D;;AAEA;EACE,6EAA6E;EAC7E,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;;;;;EAME,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB,EAAE,yCAAyC;EACjE,YAAY;AACd;;AAEA;;EAGE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;;EAEE,eAAe;EAEf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA,iCAAiC;AACjC;;;;;;EAME,mBAAmB;EACnB,aAAa;EACb,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS,EAAE,qCAAqC;EAChD,eAAe;EACf,WAAW;EACX,mBAAmB,EAAE,oCAAoC;EACzD,qBAAqB,EAAE,mDAAmD;AAC5E;;AAEA;EAEE,UAAU;EACV,YAAY,EAAE,gCAAgC;EAC9C,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,4DAA4D;EAC5D,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,qBAAqB,EAAE,kCAAkC;EACzD,eAAe;EACf,SAAS,EAAE,0BAA0B;AACvC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mGAAmG;AACrG;;AAEA;EACE,cAAc,EAAE,eAAe;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B,EAAE,uBAAuB;AACrD;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B,EAAE,+BAA+B;EAC5D,WAAW,EAAE,0CAA0C;AACzD;;AAEA;EACE,uCAAuC;EACvC,mBAAmB,EAAE,yBAAyB;EAC9C,4BAA4B;AAC9B;;AAEA,gDAAgD;AAChD;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,sCAAsC;AACvC,CAAA","sourcesContent":["html,\nbody,\n#root {\n    width: 100%;\n    height: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.su-auth-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  width: 100%;\n  height: auto;\n\n  background: rgba(239,236,239,0);\n\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.signup-box {\n  background: rgba(234, 229, 234, 1); /* 60% translucent */\n  padding: 2rem;\n  border-radius: 10px;\n  width: 600px;\n  max-width: 90%;\n  margin: 30px 0;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 0 40px rgba(0, 0, 0, 0.3);\n  /* min-height: 800px; */\n  text-align: center;\n  z-index: 1; /* Ensure login box is above the background */\n}\n\n.signup-box h2 {\n  font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif;\n  color: black;\n  font-size: 60px;\n  margin-bottom: 10px;\n  font-weight: lighter;\n}\n\n/* Input Fields */\ninput[type=\"text\"],\ninput[type=\"loc\"],\ninput[type=\"tel\"],\ninput[type=\"date\"],\nselect {\n  border-radius: 10px;\n  width: 100%;\n  min-height: 40px; \n  padding: 14px;\n  border: 1px solid #d1d7d5;\n  border-radius: 8px;\n  font-size: 18px;\n  background-color:white;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n  height: 50px;   \n}\n\ninput[type=\"password\"],\nselect {\n  border-radius: 10px;\n  width: 100%;\n  margin-top: 0;\n  min-height: 30px;\n  height: 50px; \n  padding: 14px;\n  border: 1px solid #d1d7d5;\n  border-radius: 8px;\n  font-size: 18px;\n  background-color:white;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\nselect[type=\"scroll\"],\nselect {\n  margin-top: 2px;\n  border-radius: 10px;\n  width: 100%;\n  height: auto;\n  max-height: 40px; \n  padding: 14px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 14px;\n  background-color:white;\n  box-sizing: border-box; /* Ensures padding doesn't affect width */\n}\n\n/* For first name and last name */\ninput[type=\"text\"]:focus, \ninput[type=\"email\"]:focus, \ninput[type=\"password\"]:focus, \ninput[type=\"tel\"]:focus, \ninput[type=\"date\"]:focus, \nselect:focus {\n  border-radius: 10px;\n  outline: none;\n  border-color: #28a745;\n}\n\n/* Terms & Conditions Styling */\n.terms-conditions {\n  margin-top: 15px;\n  display: flex;\n  gap: 10px; /* Space between checkbox and label */\n  font-size: 14px;\n  color: #fff;\n  margin-bottom: 20px; /* Space before the Sign-Up button */\n  align-items: baseline; /* Align the checkbox and label from the baseline */\n}\n\n.submit-otp-btn {\n  border-radius: 10px;\n  width: 20%;\n  height: 50px; /* Same height as input fields */\n  /* padding: 10px; */\n  border: 1px solid #020202;\n  border-radius: 8px;\n  font-size: 14px;\n  background-color: #28a745;\n  color: #fff;\n  font-weight: bold;\n  cursor: pointer;\n  transition: 0.3s;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n  margin-top: 10px;\n  margin-left: 20px;\n}\n\n/* Checkbox styling */\n.terms-conditions input {\n  transform: scale(1.2); /* Make checkbox slightly larger */\n  cursor: pointer;\n  margin: 0; /* Remove default margin */\n}\n\n/* Link Styling */\n.terms-conditions a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.terms-conditions a:hover {\n  text-decoration: underline;\n}\n\n.signin-prompt {\n  border-radius: 10px;\n  width: 100%;\n  height: 40px; \n  margin-top: 10px;\n  text-align: center;\n  font-size: 16px;\n  color: black;\n  padding: 5px;\n  font-family: \"'Trebuchet MS','Lucida Sans Unicode','Lucida Grande','Lucida Sans',Arial,sans-serif;\"; \n}\n\n.signin-prompt a {\n  color: #007BFF; /* Link color */\n  text-decoration: none;\n}\n\n.signin-prompt a:hover {\n  text-decoration: underline; /* Underline on hover */\n}\n\n/* Button Container */\n.button-container {\n  border-radius: 10px;\n  display: flex;\n  justify-content: flex-start; /* Aligns button to the right */\n  width: 100%; /* Ensures it takes full width of parent */\n}\n\nbutton:disabled {\n  /* background-color: #ccc !important; */\n  cursor: not-allowed; /* Show disabled cursor */\n  /* border: 1px solid #999; */\n}\n\n/* Responsive: Stack fields on smaller screens */\n@media (max-width: 600px) {\n  .form-group-row {\n    flex-direction: column;\n  }\n}\n\n.profilepic {\n  /* margin-top: 10px; */\n  display: flex;\n  align-items: center;\n  border: 1px solid #ccc;\n  padding: 6px;\n  border-radius: 6px;\n  background-color: #fff;\n  height: 40px;\n}\n\n.uploadimage {\n  flex-grow: 1;\n  /* height: 20px; */\n  border: none;\n  outline: none;\n  padding: 8px;\n  font-size: 14px;\n  background: transparent;\n}\n\n.imageupload {\n  cursor: pointer;\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.upload-icon {\n  color: gray;\n  font-size: 18px;\n}\n\n.input-field {\n  width: 100%;\n  padding: 8px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.copyright-container {\n    color: \"black\";  \n    display: \"block\";\n    font-size: \"16px\"; \n    text-align: \"center\";\n}\n\n.copyright {\n  font-size: 16px;\n}\n\n.su-popupStyle {\n  position: 'fixed';\n  margin-top: '30%';\n  left: '50%';\n  transform: 'translate(-50%, -30%)';\n  background: '#fff';\n  padding: '2rem';\n  border: '1px solid #ccc';\n  border-radius: '10px';\n  box-shadow: '0 0 10px rgba(0,0,0,0.2)';\n};"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
